module.exports = __webpack_public_path__ + "static/media/confetti.0ae89226.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/confetti.svg
// module id = 295
// module chunks = 0